import React, { useEffect, useRef, useState } from "react";
import Breadcrumb from "../../../../layouts/full-layout/breadcrumb/Breadcrumb";
import FeatherIcon from "feather-icons-react";
import {
  ChangeQuestionStatus,
  GetAllQuestions,
} from "../../../../services/human-resource";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  Card,
  CardContent,
  TableHead,
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  TableFooter,
  IconButton,
  TableSortLabel,
  TableContainer,
  Paper,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  Switch,
  FormControl,
  FormControlLabel,
  RadioGroup,
  TextField,
  Menu,
  Checkbox,
  ListItemText,
  Select
} from "@mui/material";
import CustomTextField from "../../../../components/forms/custom-elements/CustomTextField";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { routes } from "../../../../routes/routes";
import { useNavigate } from "react-router";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { DeleteVisitorById, DownloadVisitorPdf, GetAllVisitors } from "../../../../services/attendance-change";
import { Print } from "@mui/icons-material";
import CustomSelect from "../../../../components/forms/custom-elements/CustomSelect";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import dayjs from "dayjs";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DatePicker from "react-datepicker";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CustomRadio from "../../../../components/forms/custom-elements/CustomRadio";
import InputAdornment from "@mui/material/InputAdornment";
import CloseIcon from "@mui/icons-material/Close";

const BCrumb = [
  {
    to: "/",
    title: "Attendance",
  },
  {
    title: "All Visitors",
  },
];

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export const AllVisitors = () => {
  const [visitors, setVisitors] = useState([]);
  const [filter, setFiltered] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [approvalStatus, setApprovalStatus] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [orderDirection, setOrderDirection] = useState("desc");
  const [valueToOrderBy, setValueToOrderBy] = useState("Id");
  const [totalRecords, setTotalRecords] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [globalSearch, setGlobalSearch] = useState("");
  const [searchText, setSearchText] = useState({});
  const [dateRange, setDateRange] = useState([
    dayjs().startOf("year").toDate(),
    dayjs().endOf("year").toDate()
  ]);
  const [showAllFilters, setShowAllFilters] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const navigate = useNavigate();
  const [activePreset, setActivePreset] = useState("");

  const [columnAnchorEl, setColumnAnchorEl] = useState(null);

  const [visibleColumns, setVisibleColumns] = useState({
    initiatorName: true,
    selectType: true,
    visitingPersonName: true,
    visitingDate: true,
    visitingTime: true,
    validUpto: true,
    visitingType: true,
    purpose: true,
    approval: true,
  });

  const hiddenColumnCount =
    Object.values(visibleColumns).filter((v) => !v).length;

  const statusOptions = [
    { label: "Approved", value: "1" },
    { label: "Pending", value: "2" },
    { label: "Denied", value: "8" },
    { label: "Void", value: "11" },
  ];

  const debounceRef = useRef(null);

  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      getvisitors();
    }, 700);

    return () => clearTimeout(debounceRef.current);
  }, [
    rowsPerPage,
    page,
    valueToOrderBy,
    orderDirection,
    globalSearch,
    searchText,
    dateRange,
    selectedValue,
  ]);

  const setToday = () => {
    const today = new Date();
    setDateRange([today, today]);
    setPage(0);
    setActivePreset("today");
    setGlobalSearch("");
    setShowAllFilters(false);
    setSearchText({});
  };

  const setLast7Days = () => {
    setDateRange([dayjs().subtract(7, "day").toDate(), new Date()]);
    setPage(0);
    setGlobalSearch("");
    setActivePreset("last7");
    setSearchText({});
    setShowAllFilters(false);
  };

  const setThisMonth = () => {
    const start = dayjs().startOf("month").toDate();
    const end = dayjs().endOf("month").toDate();
    setDateRange([start, end]);
    setPage(0);
    setActivePreset("month");
    setGlobalSearch("");
    setSearchText({});
    setShowAllFilters(false);
  };

  const getSearchPayload = () => {
    const cleanGlobal = globalSearch?.trim();

    if (cleanGlobal) {
      return {
        searchKeyword: cleanGlobal,
        searchFilterJson: null,
      };
    }

    const activeFilters = { ...searchText };

    if (searchText.visitingDate) {
      activeFilters.fromDate = searchText.visitingDate;
      activeFilters.toDate = searchText.visitingDate;
      delete activeFilters.visitingDate;
    }

    if (selectedValue !== null) {
      activeFilters.approval =
        selectedValue === 1 ? "Approved" :
          selectedValue === 2 ? "Pending" :
            selectedValue === 8 ? "Denied" :
              selectedValue === 11 ? "Void" : null;
    }

    if (dateRange[0] && dateRange[1]) {
      activeFilters.fromDate = dayjs(dateRange[0]).format("YYYY-MM-DD");
      activeFilters.toDate = dayjs(dateRange[1]).format("YYYY-MM-DD");
    }

    return {
      searchKeyword: null,
      searchFilterJson:
        Object.keys(activeFilters).length > 0
          ? JSON.stringify(activeFilters)
          : null,
    };
  };

  const getvisitors = async () => {
    const { searchKeyword, searchFilterJson } = getSearchPayload();

    const response = await GetAllVisitors({
      start: rowsPerPage * page,
      length: rowsPerPage,
      sortExpression: `${valueToOrderBy} ${orderDirection}`,
      searchKeyword,
      searchFilterJson,
    });

    if (response?.status === 200) {
      const formattedData = response.data.result.map(v => ({
        ...v,
        validUpto: v.validUpto?.split(" ")[0],
        visitingDate: v.visitingDate?.split(" ")[0],
      }));

      setVisitors(formattedData);
      setTotalRecords(response?.data?.totalRecords);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlRequestSort = (property) => {
    const isAscending = valueToOrderBy === property && orderDirection === "asc";
    setValueToOrderBy(property);
    setOrderDirection(isAscending ? "desc" : "asc");
  };

  const handleChangeSwitch = (status, id) => {
    swal({
      title: "Confirmation",
      text: "Do you want to change the status?",
      icon: "warning",
      buttons: ["Cancel", "OK"],
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) {
        handleConfirmDelete(status, id);
      }
    });
  };

  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const handleConfirmDelete = async () => {
    try {
      if (selectedRow) {
        const response = await DeleteVisitorById(selectedRow.id);
        if (response?.status === 200) {
          toast.success("Visitor deleted successfully!");
          getvisitors();
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete the visitor.");
    } finally {
      handleClose(); // Close the modal
    }
  };

  const handlePrint = async (id) => {
    const response = await DownloadVisitorPdf(id, 1);
    if (response?.status === 200) {
      var base64Str = response?.data;
      var binaryString = window.atob(base64Str);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      var arrBuffer = bytes;
      var newBlob = new Blob([arrBuffer], { type: "application/pdf" });

      var data = window.URL.createObjectURL(newBlob);
      window.open(data, "_blank");
    }
  };
  const handleDownload = async (id, type) => {
    try {
      const response = await DownloadVisitorPdf(id, type);
      if (response?.status === 200) {
        const base64Str = response?.data;
        const binaryString = window.atob(base64Str);
        const binaryLen = binaryString.length;
        const bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
          const ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        const arrBuffer = bytes;
        const newBlob = new Blob([arrBuffer], { type: "application/pdf" });

        // Create a download link
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(newBlob);
        link.download = `Visitor_${id}.pdf`; // Set the file name
        link.click(); // Trigger the download
        setModalOpen(false);
      }
    } catch (error) {
      console.error("Failed to download the file:", error);
      toast.error("Failed to download the file.");
    }
  };

  const resetAllFilters = () => {
    setGlobalSearch("");
    setSearchText({});
    setSelectedValue(null);
    setDateRange([
      dayjs().startOf("year").toDate(),
      dayjs().endOf("year").toDate()
    ]);
    setShowAllFilters(false);
    setPage(0);
  };

  const resetForColumnFilter = () => {
    setGlobalSearch("");
    setSelectedValue(null);
    setDateRange([null, null]);
  };

  const resetForGlobalSearch = () => {
    setSearchText({});
    setSelectedValue(null);
    setDateRange([null, null]);
    setShowAllFilters(false);
  };

  const resetForRadio = () => {
    setGlobalSearch("");
    setSearchText({});
    setDateRange([null, null]);
    setShowAllFilters(false);
  };

  const hasColumnFilters = Object.values(searchText || {}).some(
    (v) => v !== null && v !== undefined && String(v).trim() !== ""
  );

  const hasDateFilter = !!dateRange[0] || !!dateRange[1];
  const hasGlobalSearch = !!globalSearch?.trim();
  const hasRadioFilter = selectedValue !== null;

  const hasActiveFilters =
    hasColumnFilters || hasDateFilter || hasGlobalSearch || hasRadioFilter;

  const activeFilterCount =
    Object.values(searchText || {}).filter(
      (v) => v !== null && v !== undefined && String(v).trim() !== ""
    ).length +
    (globalSearch ? 1 : 0) +
    (dateRange[0] || dateRange[1] ? 1 : 0) +
    (selectedValue !== null ? 1 : 0);

  const clearColumnFilter = (field) => {
    setSearchText((prev) => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });
    setPage(0);
  };

  const isColumnFiltered = (field) =>
    searchText[field] !== null &&
    searchText[field] !== undefined &&
    String(searchText[field]).trim() !== "";

  const columnFilterCount = Object.values(searchText || {}).filter(
    (v) => v !== null && v !== undefined && String(v).trim() !== ""
  ).length;

  return (
    <>
      <Breadcrumb title="All Visitors" items={BCrumb} />

      <Card sx={{ p: 0 }}>
        <Box
          display="flex"
          alignItems="center"
          p={2}
          sx={{
            backgroundColor: "primary.light",
            color: "primary.main",
          }}
        >
          <FeatherIcon icon="alert-circle" width="18" />
          <Box sx={{ ml: 1 }}>All Visitors ({totalRecords || 0})</Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(routes.addvisitor.match)}
            sx={{ ml: "auto" }}
          >
            Add Visitor
          </Button>
        </Box>
        <Card>
          <CardContent>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
              gap={2}
            >
              <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
                <FormControl>
                  <RadioGroup
                    row
                    value={selectedValue ?? "0"}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSelectedValue(value === "0" ? null : Number(value));
                      setPage(0);
                      resetForRadio();
                    }}
                  >
                    <FormControlLabel value={0} label="All" control={<CustomRadio />} />
                    <FormControlLabel value={1} label="Approved" control={<CustomRadio />} />
                    <FormControlLabel value={8} label="Denied/Void" control={<CustomRadio />} />
                    <FormControlLabel value={2} label="Pending" control={<CustomRadio />} />
                  </RadioGroup>
                </FormControl>

                <Box sx={{ width: 200, flexShrink: 0 }}>
                  <DatePicker
                    selectsRange
                    startDate={dateRange[0]}
                    endDate={dateRange[1]}
                    onChange={(update) => {
                      setDateRange(update);
                      setPage(0);
                      setGlobalSearch("");
                      setActivePreset("");
                      setShowAllFilters(false);
                    }}
                    shouldCloseOnSelect={false}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Select date range"
                    popperPlacement="bottom-start"
                    isClearable={false}
                    popperProps={{
                      modifiers: [
                        {
                          name: "zIndex",
                          enabled: true,
                          phase: "write",
                          fn: ({ state }) => {
                            state.styles.popper.zIndex = 1500;
                          },
                        },
                      ],
                    }}

                    customInput={
                      <TextField
                        size="small"
                        inputProps={{ readOnly: true }}
                        placeholder="Select date range"
                        sx={{
                          width: 200,
                          backgroundColor: "white",
                          "& .MuiInputBase-root": {
                            cursor: "pointer",
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end" sx={{ color: "black" }}>
                              <CalendarTodayIcon fontSize="small" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    }
                  />
                </Box>

                <Box display="flex" gap={0.5} flexWrap="nowrap">
                  <Button size="small" variant={activePreset === "today" ? "contained" : "outlined"} onClick={setToday}>
                    Today
                  </Button>
                  <Button size="small" variant={activePreset === "last7" ? "contained" : "outlined"} onClick={setLast7Days}>
                    Last 7 Days
                  </Button>
                  <Button size="small" variant={activePreset === "month" ? "contained" : "outlined"} onClick={setThisMonth}>
                    This Month
                  </Button>
                </Box>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                gap={0.5}
                sx={{ flexWrap: "nowrap", whiteSpace: "nowrap" }}
              >
                <TextField
                  size="small"
                  placeholder="Search..."
                  value={globalSearch}
                  onChange={(e) => {
                    setGlobalSearch(e.target.value);
                    setPage(0);
                    setActivePreset("");
                    resetForGlobalSearch();
                  }}
                  sx={{ width: 210, backgroundColor: "white" }}
                />

                <Box display="flex" alignItems="center" gap={0.5}>
                  <FilterAltIcon
                    sx={{
                      cursor: "pointer",
                      color: showAllFilters ? "primary.main" : "inherit",
                    }}
                    onClick={() => {
                      setShowAllFilters(!showAllFilters);
                      resetForColumnFilter();
                    }}
                  />

                  {hasColumnFilters && !showAllFilters && (
                    <Button
                      size="small"
                      variant="outlined"
                      sx={{
                        textTransform: "none",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        whiteSpace: "nowrap",
                      }}
                      onClick={() => setShowAllFilters(true)}
                    >
                      Filters ({columnFilterCount})

                      <CloseIcon
                        sx={{ fontSize: 16 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          resetAllFilters();
                          setActivePreset("");
                        }}
                      />
                    </Button>
                  )}
                </Box>

                <Button
                  size="small"
                  variant="outlined"
                  onClick={(e) => setColumnAnchorEl(e.currentTarget)}
                  sx={{
                    textTransform: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  Columns
                  {hiddenColumnCount > 0 && (
                    <Box
                      component="span"
                      sx={{
                        fontSize: "0.90rem",
                        color: "primary.main",
                      }}
                    >
                      ({hiddenColumnCount})
                    </Box>
                  )}
                </Button>

                <Menu
                  anchorEl={columnAnchorEl}
                  open={Boolean(columnAnchorEl)}
                  onClose={() => setColumnAnchorEl(null)}
                >
                  {[
                    ["initiatorName", "Initiator Name"],
                    ["selectType", "Select Type"],
                    ["visitingPersonName", "Person Name"],
                    ["visitingDate", "Date"],
                    ["visitingTime", "Time"],
                    ["validUpto", "Valid Upto"],
                    ["visitingType", "Type"],
                    ["purpose", "Purpose"],
                    ["approval", "Approval Status"],
                  ].map(([key, label]) => (
                    <MenuItem
                      key={key}
                      onClick={() => {
                        const visibleCount = Object.values(visibleColumns).filter(Boolean).length;

                        if (visibleColumns[key] && visibleCount === 1) return;

                        setVisibleColumns((prev) => ({
                          ...prev,
                          [key]: !prev[key],
                        }));
                      }}
                    >
                      <Checkbox size="small" checked={visibleColumns[key]} />
                      <ListItemText primary={label} />
                    </MenuItem>
                  ))}
                </Menu>

                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    resetAllFilters();
                    setActivePreset("");
                  }}
                  disabled={!hasActiveFilters && !activePreset}
                >
                  Reset Filter
                </Button>
              </Box>
            </Box>
          </CardContent>

          <CardContent>
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: showAllFilters ? 540 : 450,
                overflowY: visitors.length > 5 ? "auto" : "visible",
                overflowX: "auto",
                scrollbarGutter: "stable",
              }}
            >
              <Table
                aria-label="custom pagination table"
                stickyHeader
                sx={{ whiteSpace: "nowrap" }}
              >
                <TableHead sx={{ position: "sticky", top: 0, zIndex: 1 }}>
                  <TableRow>
                    <TableCell>Action</TableCell>

                    {visibleColumns.initiatorName && (
                      <TableCell>
                        <TableSortLabel
                          active={valueToOrderBy === "initiatorName"}
                          direction={valueToOrderBy === "initiatorName" ? orderDirection : "desc"}
                          onClick={() => handlRequestSort("initiatorName")}
                        >
                          Initiator Name
                        </TableSortLabel>
                      </TableCell>
                    )}

                    {visibleColumns.selectType && <TableCell>Select Type</TableCell>}

                    {visibleColumns.visitingPersonName && (
                      <TableCell sx={{ maxWidth: "150px" }}>Person Name</TableCell>
                    )}

                    {visibleColumns.visitingDate && (
                      <TableCell>
                        <TableSortLabel
                          active={valueToOrderBy === "visitingDate"}
                          direction={valueToOrderBy === "visitingDate" ? orderDirection : "desc"}
                          onClick={() => handlRequestSort("visitingDate")}
                        >
                          Date
                        </TableSortLabel>
                      </TableCell>
                    )}

                    {visibleColumns.visitingTime && <TableCell>Time</TableCell>}

                    {visibleColumns.validUpto && <TableCell>Valid Upto</TableCell>}

                    {visibleColumns.visitingType && <TableCell>Type</TableCell>}

                    {visibleColumns.purpose && <TableCell>Purpose</TableCell>}

                    {visibleColumns.approval && <TableCell>Approval Status</TableCell>}
                  </TableRow>
                  {showAllFilters && (
                    <TableRow>
                      <TableCell></TableCell>
                      {[
                        "initiatorName",
                        "selectType",
                        "visitingPersonName",
                        "visitingDate",
                        "visitingTime",
                        "validUpto",
                        "visitingType",
                        "purpose",
                        "approval",
                      ]
                        .filter((field) => visibleColumns[field])
                        .map((field) => (
                          <TableCell key={field}>
                            {field === "validUpto" ? (
                              <TextField
                                type="date"
                                size="small"
                                fullWidth
                                value={searchText[field] || ""}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setActivePreset("");
                                  setSearchText((prev) => {
                                    const updated = { ...prev };
                                    value?.trim() ? (updated[field] = value) : delete updated[field];
                                    return updated;
                                  });

                                  setPage(0);
                                }}
                                InputProps={{
                                  endAdornment: isColumnFiltered(field) && (
                                    <InputAdornment position="end">
                                      <IconButton size="small" onClick={() => clearColumnFilter(field)}>
                                        <CloseIcon fontSize="small" />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                InputLabelProps={{ shrink: true }}
                              />
                            ) : field === "visitingTime" ? (
                              <TextField
                                type="time"
                                size="small"
                                fullWidth
                                value={searchText[field] || ""}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setActivePreset("");
                                  setSearchText((prev) => {
                                    const updated = { ...prev };
                                    value?.trim() ? (updated[field] = value) : delete updated[field];
                                    return updated;
                                  });

                                  setPage(0);
                                }}
                                InputProps={{
                                  endAdornment: isColumnFiltered(field) && (
                                    <InputAdornment position="end">
                                      <IconButton size="small" onClick={() => clearColumnFilter(field)}>
                                        <CloseIcon fontSize="small" />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                InputLabelProps={{ shrink: true }}
                              />
                            ) : field === "visitingDate" ? (
                              <TextField
                                type="date"
                                size="small"
                                fullWidth
                                value={searchText[field] || ""}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setActivePreset("");
                                  setSearchText((prev) => {
                                    const updated = { ...prev };
                                    value?.trim() ? (updated[field] = value) : delete updated[field];
                                    return updated;
                                  });

                                  setPage(0);
                                }}
                                InputProps={{
                                  endAdornment: isColumnFiltered(field) && (
                                    <InputAdornment position="end">
                                      <IconButton size="small" onClick={() => clearColumnFilter(field)}>
                                        <CloseIcon fontSize="small" />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                InputLabelProps={{ shrink: true }}
                              />
                            ) : field === "approval" ? (
                              <Box display="flex" alignItems="center" gap={0.5}>
                                <Select
                                  size="small"
                                  fullWidth
                                  value={searchText[field] || ""}
                                  displayEmpty
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setActivePreset("");
                                    setSearchText((prev) => {
                                      const updated = { ...prev };

                                      if (value === "" || value === null || value === undefined) {
                                        delete updated[field];
                                      } else {
                                        updated[field] = value;
                                      }

                                      return updated;
                                    });

                                    setPage(0);
                                  }}
                                >
                                  <MenuItem value="">All</MenuItem>
                                  <MenuItem value="Approved">Approved</MenuItem>
                                  <MenuItem value="Pending">Pending</MenuItem>
                                  <MenuItem value="Denied">Denied</MenuItem>
                                  <MenuItem value="Void">Void</MenuItem>
                                </Select>
                                {isColumnFiltered(field) && (
                                  <IconButton size="small" onClick={() => clearColumnFilter(field)}>
                                    <CloseIcon fontSize="small" />
                                  </IconButton>
                                )}
                              </Box>
                            ) : (
                              <TextField
                                size="small"
                                fullWidth
                                placeholder="Search..."
                                value={searchText[field] || ""}
                                onChange={(e) => {
                                  setSearchText({
                                    ...searchText,
                                    [field]: e.target.value,
                                  });
                                  setActivePreset("");
                                  setPage(0);
                                  resetForColumnFilter();
                                }}
                                InputProps={{
                                  endAdornment: isColumnFiltered(field) && (
                                    <InputAdornment position="end">
                                      <IconButton size="small" onClick={() => clearColumnFilter(field)}>
                                        <CloseIcon fontSize="small" />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          </TableCell>
                        ))}
                    </TableRow>
                  )}
                </TableHead>
                <TableBody>
                  {visitors.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={Object.values(visibleColumns).filter(Boolean).length + 1}
                        align="center"
                      >
                        {hasActiveFilters ? (
                          <>
                            <div>No records match the applied filters</div>
                            <Button
                              size="small"
                              sx={{ mt: 1 }}
                              onClick={() => {
                                resetAllFilters();
                                setActivePreset("");
                              }}
                            >
                              Clear Filters
                            </Button>
                          </>
                        ) : (
                          "No data found"
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                  {visitors?.map((rows) => (
                    <TableRow key={rows?.id}>
                      <TableCell>
                        <Tooltip title={rows?.canEdit ? "Edit" : "You can only edit your own pass"}>
                          <span>
                            <IconButton
                              size="small"
                              disabled={!rows?.canEdit}
                              onClick={() =>
                                navigate(
                                  routes?.editVisitor.build(`${rows.id}`, {
                                    id: `${rows?.id}`,
                                  })
                                )
                              }
                            >
                              <FeatherIcon icon="edit-2" width="16" />
                            </IconButton>
                          </span>
                        </Tooltip>
                        &nbsp;
                        <Tooltip title="View" placement="top">
                          <IconButton
                            size="small"
                            onClick={() =>
                              navigate(
                                routes?.visitorView.build(`${rows.id}`, {
                                  id: `${rows?.id}`,
                                })
                              )
                            }
                          >
                            <RemoveRedEyeOutlinedIcon width="16" />
                          </IconButton>
                        </Tooltip>
                        &nbsp;
                        <IconButton onClick={() => handlePrint(rows?.id)}>
                          <Print />
                        </IconButton>
                        <Tooltip title="Download" placement="top">
                          <IconButton
                            onClick={() => {
                              setSelectedId(rows?.id);
                              setModalOpen(true);
                            }}
                          >
                            <FeatherIcon icon="download" width="16" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>

                      {visibleColumns.initiatorName && (
                        <TableCell
                          sx={{
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            maxWidth: 300,
                          }}
                        >
                          {rows?.initiatorName ? rows?.initiatorName : rows?.hostPersonToMeet}
                        </TableCell>
                      )}

                      {visibleColumns.selectType && (
                        <TableCell sx={{ maxWidth: 100 }}>{rows?.selectType}</TableCell>
                      )}

                      {visibleColumns.visitingPersonName && (
                        <TableCell
                          sx={{
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            maxWidth: 150,
                          }}
                        >
                          {rows?.visitingPersonName}
                        </TableCell>
                      )}

                      {visibleColumns.visitingDate && (
                        <TableCell sx={{ maxWidth: 100 }}>{rows?.visitingDate}</TableCell>
                      )}

                      {visibleColumns.visitingTime && (
                        <TableCell sx={{ maxWidth: 100 }}>{rows?.visitingTime}</TableCell>
                      )}

                      {visibleColumns.validUpto && <TableCell>{rows?.validUpto}</TableCell>}

                      {visibleColumns.visitingType && (
                        <TableCell sx={{ maxWidth: 100 }}>{rows?.visitingType}</TableCell>
                      )}

                      {visibleColumns.purpose && (
                        <TableCell>
                          <Tooltip title={rows.purpose || ""} arrow>
                            <span>
                              {rows.purpose?.length > 50
                                ? rows.purpose.substring(0, 50) + "..."
                                : rows.purpose}
                            </span>
                          </Tooltip>
                        </TableCell>
                      )}

                      {visibleColumns.approval && (
                        <TableCell sx={{ maxWidth: 100 }}>{rows?.approval}</TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow></TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>Confirm Deletion</DialogTitle>
              <DialogContent>
                Are you sure you want to delete this visitor?
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleConfirmDelete} color="error">
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
              <DialogTitle>Select Language</DialogTitle>
              <DialogContent>
                Which language do you want to download the file in?
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => handleDownload(selectedId, 1)}
                  color="primary"
                >
                  English
                </Button>
                <Button
                  onClick={() => handleDownload(selectedId, 2)}
                  color="primary"
                >
                  Gujarati
                </Button>
                <Button onClick={() => setModalOpen(false)} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
            <Box style={{ display: "flex", justifyContent: "flex-end" }}>
              <TablePagination
                rowsPerPageOptions={[
                  5,
                  10,
                  25,
                  { label: "All", value: totalRecords },
                ]}
                colSpan={10}
                count={totalRecords || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputprops: { "aria-label": "rows per page" },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Box>
          </CardContent>
        </Card>
      </Card>
    </>
  );
};